export default __webpack_public_path__ + "static/media/pin-striped.d327099b.svg";